import { createContext, RefObject } from 'react'

interface MainContextType {
  mainRef: RefObject<HTMLElement | null>
}

export const MainContext = createContext<MainContextType>({ mainRef: { current: null } })
